import {LitElement, html, css} from 'lit';
import {msg} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {baseProfileOptions, centralPowerControlOptions, zoneOptions} from '../../lightProfileSectionConfig';

@customElement('visual-lightprofile-summary-details')
export class VisualLightprofileSummaryDetails extends connect(store)(LitElement) {

	static styles = [
		css`
		.summaryDetails {
			padding: 0px 30px 100px 30px;
		  }

		  h1 {
			color: white;
			font: var(--font-info-light);
			margin-top: 25px;
			text-align: center;
			text-transform: uppercase;
		  }

		  .vl {
			border-left: 1px solid white;
			height: 100px;
			left: 50%;
			width: 1px;
			margin: auto;
			margin-left: -1px;
			margin-bottom: 20px;
			position: relative;
		  }

		  .summaryContent {
			display: grid;
			gap: 0px 0px;
			grid-auto-flow: row dense;
			grid-template-columns: 2fr 9fr;
		  }

		  .description {
			max-width: 80%;
		  }

		  .description h6 {
			color: var(--color-grey4);
			font-family: var(--font-family-light);
			font-size: var(	--font-size-sections);
			margin-bottom: 0px;
			margin-top: 10px;
		  }

		  .description h5 {
			color: var(	--color-white);
			margin-bottom: 0px;
			margin-top: 10px;
			font-family: var(--font-family-light);
			font-size: var(--font-size-widget-small);
		  }

		  .description p {
			color: var(--color-grey4);
			font: var(--font-summary-paragraph);
		  }

		  .lightDiagram {
			margin-left: 5%;
		  }

		  .additionalParams p {
			font-size: var(--font-size-widget-small);
			line-height: 15px;
			margin-bottom: 0px;
			margin-top: 40px;
		  }

		  .additionalParams h5 {
			font-family: var(--font-family-light);
			font-size: var(--font-size-widget-small);
			margin-bottom: 0px;
			margin-top: 10px;

		  }

		  .lightDiagram img {
			margin: auto;
			max-height: 100%;
			width: 100%;
		  }

		  table.paramTable {
			border: 1px solid #FFFFFF;
			border-collapse: collapse;
			float: right;
			margin: 100px 60px 0 0;
			text-align: left;
		  }

		  table.paramTable td {
			border: 1px solid #FFFFFF;
			padding: 11px;
		  }

		  table.paramTable td.noBorder {
          	border-left: none;
   			border-right: none;
		  }

		  p.paramTitle {
			color: var(--color-text-sections);
			font: var(--font-summary-table);
		  }

		  p.paramValue {
			color: var(--color-white);
			font: var(--font-summary-table);
		  }

		  .lightDiagram .gap {
			display: none;
		  }
		  @media (max-width: 768px) {

			.summaryDetails {
				padding: 0 var(--small-padding);
			}

			.summaryContent {
				display: block;
			}

			.lightDiagram {
				margin-left: 0;
			}

			.graphics {
				margin-left: 10vw;
			}

			.description{
				max-width: 100%;
			}

		   div.lightDiagram :host {
				display: flex;
				width: 100%;
				min-height: 100%;
				height: 100%;
				overflow-y: hidden;
		  }
		 }


		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.location = state.lightProfile.data.project.location;
		this.lang = state.status.lang;
	}

	render() {
		const s = this.state;
		const bpo = baseProfileOptions.find(baseProfileOption => baseProfileOption.id === this.lightProfile.project.base);
		const zpo = zoneOptions.find( zoneOption =>  zoneOption.id === this.lightProfile.project.zone);
		const power = centralPowerControlOptions.find( centralPowerControlOption =>  centralPowerControlOption.id === this.lightProfile.project.centralPowerControl);
		const label = bpo ? bpo.label[this.lang] : '';
		const description = bpo ? bpo.description[this.lang] : '';
		const zonelabel = zpo ? zpo.label[this.lang] : '';
		const powerlabel = power ? power.label[this.lang] : '';
		const powerinfo = power ? power.info[this.lang] : '';
		const zonedesc = zpo ? zpo.description[this.lang] : '';
		const zoneinfo = zpo ? zpo.info[this.lang] : '';

		return html`
			<section class="summaryDetails">
				<h1>${msg('Experience the light profile in detail')}</h1>
				<div class="vl"></div>
				<div class="summaryContent">
					<div class="description">
						<h6>${msg('Light profile')}</h6>
						<h5>${label}</h5>
						<p>${description}</p>
						<div class="additionalParams">
							<p>${msg('Zone')}</p>
							<h5>${zonelabel}</h5>
							<p>${msg('Location')}</p>
							<h5>${this.location.name}</h5>
							<p>${powerlabel}</p>
							<h5>${powerinfo}</h5>
						</div>
					</div>

					<div class="lightDiagram">
						<visual-lightprofile determine-location="summary"></visual-lightprofile>
					</div>

				</div>
			</section>


        `;
	}
}
